import gql from 'graphql-tag'

export const ordersByWeek = gql`
  query ordersByWeek($week: Int!, $year: Int!) {
    ordersByWeek(week: $week, year: $year) {
      data {
        id
        date
        submitted
        submitted_at
        editable
        products {
          id
          name
          item_number
          slug
          primary_category {
            name
          }
          pivot {
            quantity
          }
        }
        grouped_by_categories {
          name
          data {
            id
            name
            item_number
            slug
            pivot {
              quantity
            }
          }
        }
      }
      excludedDays
    }
  }
`

export const productsForWeekOrder = gql`
  query productsForWeekOrder($week: Int!, $year: Int, $categoryId: ID, $tagIds: [ID]) {
    productsForWeekOrder(week: $week, year: $year, categoryId: $categoryId, tagIds: $tagIds) {
      data {
        id
        name
        slug
        item_number
        unit
        best_before
        bioland
        weekend_product
        weekday_availability_readable
        image_path
        attachment_path
        orderable_days_in_calender_week
        orderable_from
        orderable_to
        primary_category {
          id
          name
          atypical_quantity
        }
        last_orders_quantities {
          weekday
          quantity
        }
      }
    }
  }
`


export const weekQuery = gql`
  query weekQuery($week: Int!, $year: Int!, $categoryId: ID, $tagIds: [ID]) {
    productsForWeekOrder(week: $week, year: $year, categoryId: $categoryId, tagIds: $tagIds) {
      data {
        id
        name
        slug
        item_number
        unit
        best_before
        bioland
        weekend_product
        weekday_availability_readable
        image_path
        attachment_path
        orderable_days_in_calender_week
        orderable_from
        orderable_to
        primary_category {
          id
          name
          atypical_quantity
        }
      }
    }
    ordersByWeek(week: $week, year: $year) {
      data {
        id
        date
        submitted
        submitted_at
        editable
        products {
          id
          name
          item_number
          slug
          primary_category {
            name
          }
          pivot {
            quantity
          }
        }
        grouped_by_categories {
          name
          data {
            id
            name
            item_number
            slug
            pivot {
              quantity
            }
          }
        }
      }
      excludedDays
    }
  }
`
